import React from 'react';
import Icon from '../../../components/AppIcon';

const FormProgress = ({ currentStep, totalSteps, completedSections }) => {
  const sections = [
    { id: 'basic', label: 'Basic Info', icon: 'AlertTriangle' },
    { id: 'systems', label: 'Systems', icon: 'Server' },
    { id: 'assignment', label: 'Assignment', icon: 'Users' },
    { id: 'tags', label: 'Tags', icon: 'Tag' },
    { id: 'attachments', label: 'Evidence', icon: 'Paperclip' }
  ];

  const getStepStatus = (sectionId, index) => {
    if (completedSections?.includes(sectionId)) return 'completed';
    if (index === currentStep) return 'current';
    return 'pending';
  };

  const getStepClasses = (status) => {
    switch (status) {
      case 'completed':
        return 'bg-success text-success-foreground border-success';
      case 'current':
        return 'bg-primary text-primary-foreground border-primary';
      default:
        return 'bg-muted text-muted-foreground border-border';
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 mb-6">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-medium text-foreground">Form Progress</h3>
        <span className="text-xs text-muted-foreground">
          {completedSections?.length} of {sections?.length} sections completed
        </span>
      </div>
      <div className="flex items-center space-x-2 overflow-x-auto pb-2">
        {sections?.map((section, index) => {
          const status = getStepStatus(section?.id, index);
          const isLast = index === sections?.length - 1;

          return (
            <React.Fragment key={section?.id}>
              <div className="flex flex-col items-center space-y-1 min-w-0 flex-shrink-0">
                <div className={`w-8 h-8 rounded-full border-2 flex items-center justify-center transition-colors duration-200 ${getStepClasses(status)}`}>
                  {status === 'completed' ? (
                    <Icon name="Check" size={14} />
                  ) : (
                    <Icon name={section?.icon} size={14} />
                  )}
                </div>
                <span className={`text-xs font-medium text-center ${
                  status === 'current' ? 'text-primary' : 
                  status === 'completed' ? 'text-success' : 'text-muted-foreground'
                }`}>
                  {section?.label}
                </span>
              </div>
              {!isLast && (
                <div className={`flex-1 h-0.5 mx-2 transition-colors duration-200 ${
                  completedSections?.includes(section?.id) ? 'bg-success' : 'bg-border'
                }`} />
              )}
            </React.Fragment>
          );
        })}
      </div>
      <div className="mt-3">
        <div className="w-full bg-muted rounded-full h-2">
          <div 
            className="bg-primary h-2 rounded-full transition-all duration-300"
            style={{ width: `${(completedSections?.length / sections?.length) * 100}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default FormProgress;